export const isMoreThanThreeMonths = (openedAtVal: string | number | Date) => {
  if (!openedAtVal) return true
  const opened = new Date(openedAtVal)
  const threeMonthsLater = new Date(opened)
  threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3)
  return Date.now() > threeMonthsLater.getTime()
}
